module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre13",
    attrs: {
      "id": "pgepubid00025"
    }
  }, [_vm._v("TO"), _c('br', {
    staticClass: "calibre21"
  }), _vm._v("\nSIR WALTER GRINDLAY SIMPSON, BART.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('i', {
    staticClass: "calibre22"
  }, [_vm._v("My dear Cigarette")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('i', {
    staticClass: "calibre22"
  }, [_vm._v("It was enough that you should have shared so liberally in\nthe rains and portages of our voyage")]), _vm._v("; "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("that you should have\nhad so hard a paddle to recover the derelict")]), _vm._v("\n‘"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("Arethusa")]), _vm._v("’ "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("on the flooded Oise")]), _vm._v("; "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("and\nthat you should thenceforth have piloted a mere wreck of mankind\nto Origny Sainte-Benoîte and a supper so eagerly\ndesired")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("It was perhaps more than enough")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("as\nyou once somewhat piteously complained")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("that I should have\nset down all the strong language to you")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("and kept the\nappropriate reflexions for myself")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("I could not in\ndecency expose you to share the disgrace of another and more\npublic shipwreck")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("But now that this voyage of ours\nis going into a cheap edition")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("that peril")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("we shall\nhope")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("is at an end")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("and I may put your name on the\nburgee")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('i', {
    staticClass: "calibre22"
  }, [_vm._v("But I cannot pause till I have lamented the fate of our two\nships")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("That")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("sir")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("was not a fortunate\nday when we projected the possession of a canal barge")]), _vm._v("; "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("it\nwas not a fortunate day when we shared our day-dream with the\nmost hopeful of day-dreamers")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("For a while")]), _vm._v(",\n"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("indeed")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("the world looked smilingly")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("The\nbarge was procured and christened")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("and as the")]), _vm._v("\n‘"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("Eleven Thousand Virgins of Cologne")]), _vm._v(",’ "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("lay\nfor some months")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("the admired of all admirers")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("in a\npleasant river and under the walls of an ancient town")]), _vm._v(". \n"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("M. Mattras")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("the accomplished carpenter of Moret")]), _vm._v(",\n"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("had made her a centre of emulous labour")]), _vm._v("; "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("and you will\nnot have forgotten the amount of sweet champagne consumed in the\ninn at the bridge end")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("to give zeal to the workmen and\nspeed to the work")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("On the financial aspect")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("I\nwould not willingly dwell")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("The")]), _vm._v(" ‘"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("Eleven\nThousand Virgins of Cologne")]), _vm._v("’ "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("rotted in the stream\nwhere she was beautified")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("She felt not the impulse\nof the breeze")]), _vm._v("; "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("she was never harnessed to the patient\ntrack-horse")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("And when at length she was sold")]), _vm._v(",\n"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("by the indignant carpenter of Moret")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("there were sold\nalong with her the")]), _vm._v(" ‘"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("Arethusa")]), _vm._v("’ "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("and\nthe")]), _vm._v(" ‘"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("Cigarette")]), _vm._v(",’ "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("she of cedar")]), _vm._v(",\n"), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("she")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("as we knew so keenly on a portage")]), _vm._v(", "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("of\nsolid-hearted English oak")]), _vm._v(".  "), _c('i', {
    staticClass: "calibre22"
  }, [_vm._v("Now these historic\nvessels fly the tricolor and are known by new and alien\nnames")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "calibre12"
  }, [_c('i', {
    staticClass: "calibre22"
  }, [_vm._v("R. L. S.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0